import React from "react";
import { FiDownload } from "react-icons/fi";
import { Spinner } from "@chakra-ui/react";

interface PdfExportButtonProps {
	onClick: () => void;
	isExporting: boolean;
	label?: string;
}

export const PdfExportButton: React.FC<PdfExportButtonProps> = ({
	onClick,
	isExporting,
	label = "Export PDF",
}) => {
	return (
		<button
			type="button"
			className="flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
			onClick={onClick}
			disabled={isExporting}
			data-testid="pdf-export-button"
		>
			{isExporting ? (
				<Spinner size="xs" />
			) : (
				<FiDownload className="h-4 w-4" />
			)}
			{label}
		</button>
	);
};
